import React from "react";
import Card from "react-bootstrap/Card";

const ToolkitFeedbackVA = () => {
  return (
    <Card>
        <Card.Header className="font-weight-bold">
            Guidance Toolkit and Feedback
        </Card.Header>
        <Card.Body>
            <p>
                The Guidance Toolkit is a best practices document to help improve electronic health record physician alerting. In it, you will find tips and useful feedback for you and your facility.
            </p>
            <p>
                You can find the Guidance Toolkit here: <a href="../../../pdfs/VA CPOE.EHR_Toolkit_GuidanceDocumentwd_Final.pdf" target="_blank" rel="noreferrer">VA EHR/CPOE Evaluation Toolkit: Guidance for Medication-related Clinical Decision Support</a>
            </p>
            <p>
                Feedback can be sent directly to the EHR Safety Team at: <a href="mailto:Helpdesk_EHRSafetyEvalTool@utah.edu">Helpdesk_EHRSafetyEvalTool@utah.edu</a>
            </p>
        </Card.Body>
    </Card>
  );
};

export default ToolkitFeedbackVA;
